export default __webpack_public_path__ + "static/media/logo-text.44ced137.svg";